import { createGlobalStyle } from 'styled-components';
import THEME from '../theme.js';
export default createGlobalStyle `
  body {
    margin: 0;
    font-family: sans-serif;
    overflow: hidden;
  }

    a:focus {
    text-decoration: underline !important;
    outline: none;
  }

  * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    font-family: sans-serif;
    box-sizing: border-box;
  }

  *:before,
  *:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .__react_component_tooltip {
    max-width: 300px;
  }

  .react-tooltip {
    z-index: 1000;
    max-width: 320px;
    overflow-wrap: break-word;
    white-space: normal;
  }

  .react-datepicker__time-list {
    padding: 0;
  }

  .react-datepicker {
    font-family: inherit !important;
    border: none !important;
    box-shadow: 0 20px 70px -30px rgba(0,0,0,.75);
  }

  .react-datepicker-popper {
    z-index: 200 !important;
  }

  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
    width: 100px !important;
  }

  .react-datepicker__time-container {
    width: 100px !important;
    position: absolute;
    left: 100%;
  }

  .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
    right: 10px !important;
  }

  .react-datepicker__triangle {
    &:before {
      bottom: 0px !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      border-right-color: transparent !important;
      border-left-color: transparent !important;
    }
  }

  .react-datepicker__header {
    border-bottom: none !important;
  }

  .react-datepicker__time-container {
    border-left: 1px solid ${THEME.BORDER_STRONG} !important;
  }

  .react-datepicker__day--keyboard-selected {
    background-color: ${THEME.COLOR_ACCENT} !important;
    opacity: 0.7;
  }

  .react-datepicker__time-list-item--selected {
    background-color: ${THEME.COLOR_ACCENT} !important;
  }

  .react-datepicker__day--selected {
    background-color: ${THEME.COLOR_ACCENT} !important;

    &:hover {
      opacity: 0.7;
    }
  }

  .react-datepicker__input-container {
    display: block;
  }

  .react-datepicker__input-container input {
    width: 100%;
  }

  .rdw-editor-wrapper {
    background: transparent;
    .rdw-editor-toolbar {
      border-radius: 3px;
      background-color: #fff;
      border: 1px solid ${THEME.BORDER_STRONG};
      margin-top: -5px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      position: sticky;
      top: 0px;
      z-index: 2;
    }
    .rdw-editor-main {
      padding: 10px;
      min-height: 200px;
      height: 100%;
      overflow: visible;
      outline: none;
      border-radius: 3px;
      background-color: ${THEME.SURFACE_MUTED};
      width: 100%;
      background-image: none;
      border: 1px solid ${THEME.BORDER_STRONG};
      margin-top: -5px;
      border-top: none;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
    .rdw-suggestion-dropdown {
      min-width: 250px;
      max-height: 350px;
    }
    .rdw-mention-link {
      text-decoration: none;
      color: ${THEME.COLOR_PRIMARY};
      background-color: #f0fbff;
      padding: 1px 3px;
      border: 1px solid ${THEME.BORDER_STRONG};
    }
  }

  .notifications-tr {
    top: 55px !important;
  }

  .notification .notification-title,
  .notification .notification-message {
    color: ${THEME.COLOR_PRIMARY} !important;
  }

  .notification .notification-action-wrapper .notification-action-button {
    background-color: ${THEME.COLOR_PRIMARY} !important;
    color: ${THEME.COLOR_SECONDARY} !important;
  }

  .notification {
    border-top-color: ${THEME.COLOR_PRIMARY} !important;
    background-color: ${THEME.COLOR_SECONDARY} !important;
    text-align: left !important;
  }

  .notification.notification-error {
    border-top-color: ${THEME.DANGEROUS} !important;
  }

  .notification-dismiss {
    background-color: transparent !important;
    color: ${THEME.COLOR_PRIMARY} !important;
  }

  .select__control, .Select-control {
    border: 1px solid ${THEME.BORDER_STRONG} !important;
    background-color: transparent !important;
    font-family: sans-serif !important;

    .select__placeholder, .Select-placeholder {
      opacity: 0.6 !important;
      font-size: 0.8em !important;
      font-weight: bold !important;
      color: inherit !important;
    }

    .select__value-container {
      padding-left: ${15}px !important;
     }

    .Select-value, .select__multi-value {
      background-color: ${THEME.DARK_COLOR_SECONDARY};
      color: ${THEME.COLOR_PRIMARY};
      background-color: ${THEME.FILL};
    }
  }

  .note-tooltip-theme {
    background-color: ${THEME.BACKGROUND} !important;
    color: #000000 !important;
  }

  .DraftEditor-editorContainer {
    z-index: auto;
  }

  .style-as-input-field {
    .rdw-editor-main {
      min-height: 40px !important;
      border-top-left-radius: 3px !important;
      border-top-right-radius: 3px !important;
      border-top: 1px solid ${THEME.BORDER_STRONG} !important;

      .public-DraftStyleDefault-block {
        margin: 0 !important;
      }
    }
  }

  .hide-toolbar { display:none !important; }

  .__react_component_tooltip.place-top::before {
    height: 7px !important;
  }

`;
//# sourceMappingURL=GlobalStyle.js.map